import { Device } from 'dashboard/models/device';
import AccountDeviceDetail from 'dashboard/views/DashboardAccountsShowView/components/AccountDeviceDetail';

interface AccountDevicesSectionProps {
  devices: Device[];
  handleRemoveDevice: (deviceId: string) => void;
  isRedacted: boolean;
}

const AccountDevicesSection = ({
  devices,
  handleRemoveDevice,
  isRedacted,
}: AccountDevicesSectionProps) => {
  return (
    <div>
      {devices.map((device) => {
        return (
          <AccountDeviceDetail
            key={device.id}
            device={device}
            handleRemoveDevice={handleRemoveDevice}
            isRedacted={isRedacted}
          />
        );
      })}
    </div>
  );
};

export default AccountDevicesSection;
